import { memo } from 'react';

import { GROUPS_GRID_CLASS } from '../../constants/groups';
import GroupCard from './GroupCard';

/**
 * Responsive card grid of the Groups tab (no dedicated grid export in `@aimsos/ui`).
 *
 * @param {object} props
 * @param {object[]} props.groups UI groups.
 * @param {(groupId: string) => void} props.onOpen Stable callback.
 */
const GroupsGrid = ({ groups, onOpen }) => (
  <div data-testid="groups-grid" className={GROUPS_GRID_CLASS}>
    {groups.map((group) => (
      <GroupCard key={group.id} group={group} onOpen={onOpen} />
    ))}
  </div>
);

export default memo(GroupsGrid);
